export default __webpack_public_path__ + "static/media/clock.cd5ff517.png";